import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

export default {
    container: (): string =>
        buildCssClassName(
            "flex",
            "items-center",
            "px-[15px]",
            "md:px-[80px]",
            "gap-x-[15px]",
            "md:gap-x-[40px]",
            "bg-blue-500",
            "w-full"
        ),
    item: ({ isCurrent }: { isCurrent: boolean }): string =>
        buildCssClassName(
            "h-[50px]",
            "md:h-[60px]",
            "flex",
            "items-center",
            "border-b-[1px]",
            "border-t-transparent",
            "border-l-transparent",
            "border-r-transparent",
            isCurrent
                ? [
                      "focus-visible:border-l-blue-200",
                      "focus-visible:border-t-blue-200",
                      "focus-visible:border-r-blue-200",
                      "border-b-blue-200",
                      "font-[800]"
                  ]
                : ["border-b-transparent", "hover:border-b-gray-200", "focus-visible:border-b-gray-200"]
        ),
    link: ({ isCurrent }: { isCurrent: boolean }): string =>
        buildCssClassName(
            "h-full",
            "!outline-none",
            "py-[15px]",
            "md:py-[20px]",
            "px-[5px]",
            "md:px-[15px]",
            "xl:px-[20px]",
            "text-center",
            "border-b-[1px]",
            "text-[14px]",
            "leading-[21px]",
            "md:text-[16px]",
            "md:leading-[24px]",
            "font-[300]",
            isCurrent
                ? [
                      "border-b-blue-200",
                      "text-blue-200",
                      "hover:text-blue-200",
                      "focus-visible:text-blue-200",
                      "font-[800]"
                  ]
                : ["border-b-transparent", "text-gray-200", "hover:text-gray-100", "focus-visible:text-gray-100"],
            getTransitionTwClasses("all", 200)
        )
}
